export const INPUT_CVV_MASK = [/\d/, /\d/, /\d/, /\d/]
